// extracted by mini-css-extract-plugin
export default {"paper":"Auth_paper__A4TDW","form":"Auth_form__dV44t","submit":"Auth_submit__ulPXK","background":"Auth_background__3XWZo","gradient":"Auth_gradient__szlA4"};